import React,{createContext, useEffect, useState} from 'react'
import Firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/auth'
import {useAuthState} from "react-firebase-hooks/auth";
import {useCollection} from 'react-firebase-hooks/firestore';

export const FavoritesContext = createContext(undefined);

export const FavoritesProvider = (props: any) => {

    const [favorites, setFavorites] = useState<any>(undefined);
    const [user] = useAuthState(Firebase.auth());
    let userID = user ? user.uid : 'null'
    const [favoritesData] = useCollection(
        Firebase.firestore()
            .collection('users')
            .doc(userID).collection('Favorites')
    );

    useEffect(() => {
        if (favoritesData) {
            if (favoritesData.docs.length > 0) {
                let temp: any = {};
                for (let doc of favoritesData.docs) {
                    temp[doc.id] = doc.data().value
                }
                setFavorites(temp)
            }
        }

    }, [favoritesData]);

    return(
        <FavoritesContext.Provider value={favorites}>
            {props.children}
        </FavoritesContext.Provider>
    )
};
